import { Component } from "preact";
import style from "./style";
import ProgressBar from "../../components/tmp_progress_bar";
import { getSDGImageFromCode } from "../../utils/commonActionUtils";

export default class SideBarItem extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      styles: {
        alloted_budget: {
          color: this.props.data.color,
          fontSize: 18,
          fontWeight: 600,
          textTransform: "uppercase",
        },
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      styles: {
        alloted_budget: {
          color: nextProps.data.color,
          fontSize: 18,
          fontWeight: 600,
          textTransform: "uppercase",
        },
      },
    });
  }

  handleLangChange = () => {
    var flag = true;
    this.props.onSelectLanguage && this.props.onSelectLanguage(flag);
  };

  render() {
    const selectedRow = this.props.data.sdg_name
      ? this.props.data.sdg_code
      : this.props.data.sector;
    const type = this.props.data.sdg_name ? "sdg" : "sector";
    const item = this.props.data;
    const sdg_src = item.sdg_code && getSDGImageFromCode(item.sdg_code);
    const ssIcon = item.signature_solution
      ? item.ss_id === "0"
        ? "/static/assets/icons/placeHolder.svg"
        : this.props.apiBase + "/media/ss-icons/SS-" + item.ss_id + ".svg"
      : "";
    return (
      <div
        className={
          this.props.selected ? style.mainWrapperSelected : style.mainWrapper
        }
        onClick={(e) => {
          e.stopPropagation();
          this.props.selectRow &&
            this.props.selectRow(selectedRow, this.props.index, type);
        }}
      >
        <div className={style.contentWrapper}>
          <div>
            <div className={style.headerWrapper}>
              <div>
                <img
                  src={
                    item.signature_solution
                      ? ssIcon
                      : this.props.apiBase + `/static/assets/icons/${sdg_src}`
                  }
                  alt="sdg image"
                />
              </div>
              <div>
                <a
                  href={`/sdg/${item.sdg_code}/${item.sdg_name}`}
                  target={this.props.embed ? "_blank" : ""}
                >
                  {item.sdg_name}
                </a>
              </div>
            </div>
            <div className={style.progressWrapper}>
              <ProgressBar
                tabSelected={this.props.tabSelected}
                percentage={item.share_percent}
                color={item.color}
              />
            </div>
            <div className={style.footerWrapper}>
              <span>programme and project budgets is for this SDG</span>
            </div>
          </div>
          <div>
            <div class={style.desktopVisible}>
              {!this.props.embed ? (
                <i
                  class="fas fa-chevron-right"
                  onClick={() => this.handleLangChange()}
                />
              ) : undefined}
            </div>
            <div class={style.mobileVisible}>
              {!this.props.embed ? (
                <i
                  class="fas fa-chevron-right"
                  onClick={() => {
                    this.props.selectMap && this.props.selectMap();
                  }}
                />
              ) : undefined}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/tmp_sidebar_item_sdg/index.js